import { Auth } from "aws-amplify";

export const buildRequestConfig = async () => {
  const authToken = (await Auth.currentSession()).getIdToken().getJwtToken();
  const actAsUserId = localStorage.getItem('actAsUserId');
  const Authorization = actAsUserId
    ? `${authToken}|${actAsUserId}`
    : `${authToken}`;
  return {
    headers: {
      "content-type": "application/json",
      Authorization: Authorization,
    },
  };
};
